
<div class="blog-item mb-4">
    <a class="image" :href="itemSrc">
        <img v-if="item.image" :src="item.image.public_path + '?size=entry'" class="blog-image" :alt="item.image.alt" width="400" height="320"/>
    </a>

    <div class="body blog-item-body">
        <div class="d-flex flex-column">
            <h6 class="blog-item-taxonomy" v-if="item.taxonomies">{{item.taxonomies.map(taxonomy => taxonomy.title).join(', ')}}</h6>
            <h4 class="blog-item-h4"><a :href="itemSrc">{{ item.title }}</a></h4>
            <div class="ellipsis" v-html="item.blurb"></div>
        </div>

        <a class="btn btn-danger flex-nowrap d-flex align-items-center justify-content-end" :href="itemSrc">
            <span class="">{{btnText}}</span>
            <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18">
        </a>
    </div>
</div>
